import React from 'react';
import Default from './Footer';
import Basic from './Footer.Basic';

export default function Footer({ variant, ...rest }) {
  console.log(variant);
  switch (variant) {
    case 'basic':
      return <Basic {...rest} />;
    default:
      return <Default {...rest} />;
  }
}

export { default as FooterNavItem } from './FooterNavItem';
